import { Global } from '@emotion/react'

const Fonts = () => (
  <Global
    styles={`
      @font-face {
        font-family: 'Lato';
        src: local('Lato'), url('./Lato-Regular.ttf') format('ttf');
      }
    `}
  />
)

export default Fonts